// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"11":"2649a9f0","14":"e0a5406d","36":"afbb04ed","74":"93f32cbb","664":"6bdbc9dc","807":"9a09da42"}[chunkId] + ".css";
};